<template>
  <div class="welcome">
    <div class="wrapper">
      <img
        src="~/../assets/are-you-driver-enough.svg"
        alt="Are you driver enough?">
      <img
        src="~/../assets/logo.svg"
        class="logo"
        alt="BFGoodrich">
      <div class="button-wrapper">
        <button
          @click="$emit('changeView', 'game')"
          class="btn btn-primary btn-block">Iniciar Juego
        </button>
        <button
          @click="$emit('activateInnerView', 'instructions')"
          class="btn btn-primary btn-block">Instrucciones
        </button>
      </div>
    </div>
    <div class="desert"/>
  </div>
</template>

<script>
export default {
  name: 'WelcomeView'
}
</script>

<style lang="scss" scoped>
.welcome {
  height: 100%;
  width: 100%;
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#1e5799+0,2989d8+50,7db9e8+100 */
  background: #1e5799; /* Old browsers */
  background: -moz-linear-gradient(
    top,
    #1e5799 0%,
    #2989d8 50%,
    #7db9e8 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    #1e5799 0%,
    #2989d8 50%,
    #7db9e8 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    #1e5799 0%,
    #2989d8 50%,
    #7db9e8 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient(
      startColorstr="#1e5799",
      endColorstr="#7db9e8",
      GradientType=0
    ); /* IE6-9 */
}
.wrapper {
  height: 400px;
  max-width: 400px;
  margin: 0px auto;
  padding: 20px;
  .logo {
    display: block;
    max-width: 220px;
    margin: 40px auto;
  }
  .button-wrapper {
    width: 100%;
    max-width: 250px;
    margin: 0 auto;
  }
}
.desert {
  background-image: url("~/../../assets/desierto.png");
  width: 100%;
  height: 60%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}
</style>



// WEBPACK FOOTER //
// src/modules/simon-game/views/welcome-view.vue